import GraphQL from '@app/model/_common/service/GraphQL';
import { gql } from 'graphql-request';
import { MARKET_REGION_STATE_FRAGMENT } from '@app/model/market_area/service/MarketAreaStateGraphQLFragments';

export const FIND_MARKET_REGION_STATE_FOR_PERIOD_QUERY: GraphQL = {
	name: 'findMarketRegionForPeriodStatesComparison',
	gql: gql`
      ${MARKET_REGION_STATE_FRAGMENT}
      query findMarketRegionForPeriodStatesComparison($companyHotelId: Long!, $fromDate: LocalDate!, $toDate: LocalDate!) {
          findMarketRegionForPeriodStatesComparison(companyHotelId: $companyHotelId, fromDate: $fromDate, toDate: $toDate) {
              marketArea {
                  id
                  name
                  creationDate
                  country {
                      id
                      name
                  }
              }
              marketRegion {
                  id
                  name
                  creationDate
              }
              current {
                  ...MarketRegionStateFragment
              }
              previous {
                  ...MarketRegionStateFragment
              }
          }
      }
	`,
};
export const FIND_MARKET_REGION_STATE_FOR_STAT_DAY_QUERY: GraphQL = {
	name: 'findMarketRegionForStatDateStateComparison',
	gql: gql`
      ${MARKET_REGION_STATE_FRAGMENT}
      query findMarketRegionForStatDateStateComparison($companyHotelId: Long!, $statDate: LocalDate!) {
          findMarketRegionForStatDateStateComparison(companyHotelId: $companyHotelId, statDate: $statDate) {
              marketArea {
                  id
                  name
                  creationDate
                  country {
                      id
                      name
                  }
              }
              marketRegion {
                  id
                  name
                  creationDate
              }
              current {
                  ...MarketRegionStateFragment
              }
              previous {
                  ...MarketRegionStateFragment
              }
          }
      }
	`,
};

export const FIND_MARKET_REGION_STATE_FOR_STAT_DAY_BEFORE_DAYS_QUERY: GraphQL = {
	name: 'findMarketRegionForStatDateBeforeDate',
	gql: gql`
      ${MARKET_REGION_STATE_FRAGMENT}
      query findMarketRegionForStatDateBeforeDate($companyHotelId: Long!, $statDate: LocalDate!, $beforeDays: Int!) {
          findMarketRegionForStatDateBeforeDate(companyHotelId: $companyHotelId, statDate: $statDate, beforeDays: $beforeDays) {
              ...MarketRegionStateFragment
          }
      }
	`,
};

export const FIND_PREVIOUS_MARKET_REGION_STATE_FOR_STAT_DAY_QUERY: GraphQL = {
	name: 'findPreviousMarketRegionState',
	gql: gql`
      ${MARKET_REGION_STATE_FRAGMENT}
      query findPreviousMarketRegionState($companyHotelId: Long!, $statDate: LocalDate!) {
          findPreviousMarketRegionState(companyHotelId: $companyHotelId, statDate: $statDate) {
              ...MarketRegionStateFragment
          }
      }
	`,
};

export const FIND_MARKET_AREAS: GraphQL = {
	name: 'findMarketAreas',
	gql: gql`
			query findMarketAreas {
					findMarketAreas {
							id
							name
							creationDate
							country {
									id
									name
							}
					}
			}
	`,
};